import { render, staticRenderFns } from "./Scoring2.vue?vue&type=template&id=0ac27928&"
import script from "./Scoring2.vue?vue&type=script&lang=js&"
export * from "./Scoring2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports